import { useState } from 'react';
import { ReactComponent as VisibilityIcon } from "../../../../icons/visibility.svg";
import { ReactComponent as CloseIcon } from "../../../../icons/close.svg";
import Modal from '../../../../components/modalWindow/modal';
import ButtonField from '../../../../components/buttonField/buttonField';
import { classNameBtn } from '../../../../components/shared/button/types/buttonProps';
import { CollectivePreviewModalProps } from './types/collectivePreviewModalProps';
import './collectivePreviewModal.scss';

const CollectivePreviewModal = (props: CollectivePreviewModalProps) => {
    const [data, setData] = useState<any>([...props.data]);
    const [deleteIds, setDeleteIds] = useState<number[]>([]);

    const confirm = () => {
        props.onConfirm(deleteIds);
    }

    const onClose = () => {
        props.onConfirm([]);
    }

    const onDeleteClick = (id: number) => {
        const newData = data.filter((d: any) => d.id !== id);
        setDeleteIds([...deleteIds, id]);
        setData(newData);
    }

    return (
        <Modal
            title={props.title}
            titleIcon={VisibilityIcon}
            iconClass='titleIconPrimary'
            width={'700px'}
            height={'50vh'}
            actionBtns={props.preventDelete ? [] : [
                <ButtonField
                    key={1}
                    BtnProps={{
                        onClick: confirm,
                        className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium`
                    }}
                    placeHolder="Zapisz i wyjdź"
                />
            ]}
            onClose={onClose}>
            <div>
                {props.children}
                <table className='collective-preview-table' cellSpacing={0}>
                    <thead>
                        <tr>
                            <th key={1}>ID</th>
                            <th key={2}>Wartość</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((d: any) => {
                            return <tr key={d.id}>
                                <td>
                                    <div className='preview-action-td'>
                                        {props.preventDelete ? null : <CloseIcon title='Usuń' onClick={() => onDeleteClick(d.id)} />} {d.id}
                                    </div>
                                </td>
                                <td>
                                    {d.value}
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
        </Modal>
    )
}

export default CollectivePreviewModal;